export { default } from './Colophon';
